import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { registry as createMicrofrontendsRegistry } from '@cian/mf-registry/browser';

import { IAppContext, IAppContextCustom } from '../../../shared/common/types/applicationContext';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export function createApplicationContext(): IAppContext {
  const config = getConfig();

  return {
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
    microfrontendsRegistry: createMicrofrontendsRegistry(),
    microfrontendsAPI: createMicrofrontendsAPI(),
    custom: config.getStrict<IAppContextCustom>('applicationContext.custom'),
  };
}
